import React from 'react';
import {
    Stack,
    IconButton,
    Typography,
} from '@mui/material';
import { IconPencil, IconTrash } from '@tabler/icons';
import MyDataGrid from '../../../common/components/MyDataGrid';
import { capitalize } from 'lodash';
// import { Share, Assignment } from "@mui/icons-material";

const columns = [
    { field: 'name', headerName: 'Clinic Name', width: 200, flex: 1, renderCell: (params) => {
      return (
        <Stack direction="row" alignItems="center" spacing={1}>
          <Typography>{params.row.name}</Typography>
        </Stack>
      );
    }},
    { field: 'code', headerName: 'Clinic Code', width: 130 },
    { field: 'referral_network', headerName: 'Referral Group', width: 130, valueGetter: params => {
        const name = params.row?.referral_network?.name;
        return capitalize(name);
      }, },
    { field: 'organization', headerName: 'Organization', width: 130, valueGetter: params => {
        const name = params.row?.organization?.name;
        return capitalize(name);
      }, },
    { field: 'full_address', headerName: 'Address', width: 300, flex: 1 },
    {
        field: 'actions',
        headerName: 'Actions',
        sortable: false,
        width: 210,
        headerAlign: 'center',
        renderCell: (params) => {
            return  (
                <Stack direction="row" spacing={1} sx={{m: "auto"}}>
                    <IconButton
                        onClick={(e) => {
                            e.stopPropagation();
                            params.row.actions.onEdit(params.row.id);
                        }}>
                        <IconPencil />
                    </IconButton>
                    <IconButton
                        onClick={(e) => {
                            e.stopPropagation();
                            params.row.actions.onDelete(params.row.id);
                        }}>
                        <IconTrash />
                    </IconButton>
                </Stack>
            );
        }
    },
];

export default function ClinicsTable({
    onFilterChanged,
    onAdd,
    onDelete,
    onEdit,
    onSelectedRowsChanged,
    loading,
    data,
}) {
    return (
        <MyDataGrid
            onFilterChanged={onFilterChanged}
            onAdd={onAdd}
            addButtonText="Enroll Clinic"
            onDelete={onDelete}
            onEdit={onEdit}
            onSelectedRowsChanged={onSelectedRowsChanged}
            loading={loading}
            data={data}
            columns={columns}
            getRowId={(row) => {
                return row.id;
            }}
            minTableHeight={'calc(100vh - 232px)'}
        />
    );
}
